import { render } from "./index.vue?vue&type=template&id=0ada1392&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0ada1392&lang=scss&scoped=true"

import exportComponent from "/Users/alvinmamangon/Local/sites/medicomm/ppd/pdha.thefilipinodoctor.com-stage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ada1392"]])

export default __exports__